import React from 'react';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import classnames from 'classnames';
import TabPropTypes from './Tab.propTypes';

const Tab = ({ id, iconType, title, isActive, className, notification, handleSelectTab }) => {
	const classes = classnames('c-m-tab-nav__item', className, { 'c-m-tab-nav__item--active': isActive });
	const handleClick = () => handleSelectTab(id);
	const hasNotification = !!notification || notification === 0;
	return (
		<li role="presentation" className={classes}>
			<button
				data-cy={`payment-type-tab-${id.toLowerCase()}`}
				role="tab"
				id={`tab-nav-${id}`}
				aria-controls={id}
				className="c-m-tab-nav__control"
				onClick={handleClick}
			>
				{iconType && (
					<div className="c-m-tab-nav__icon">
						<Icon iconType={iconType} />
					</div>
				)}
				<div className="c-m-tab-nav__content">
					<div className="c-m-tab-nav__title">{title}</div>
					{hasNotification && <div className="c-m-tab-nav__notification">{notification}</div>}
				</div>
			</button>
		</li>
	);
};

Tab.propTypes = TabPropTypes;

export default Tab;
